import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import type { SshKey } from '@partiri-cloud/types';

/**
 * @file sshkeys.ts
 * Class for the apikeys for the users and public API
 */
export class SshKeysApi {
  protected endpoint = '/sshkeys'

  constructor(private readonly http: HttpClient) { }

  /**
   * Get list of user ssh keys
   */
  public list(): Observable<SshKey[]> {
    return this.http.get<SshKey[]>(this.endpoint)
  }

  /**
   * Generate ssh keys
   * @returns 
   */
  public generate(): Observable<SshKey> {
    return this.http.get<SshKey>(this.endpoint)
  }

  /**
   * Save ssh key for user
   * @param apiKeyOptions 
   * @returns 
   */
  public create(apiKeyOptions: SshKey): Observable<SshKey> {
    return this.http.post<SshKey>(this.endpoint, apiKeyOptions)
  }

  /**
   * Delete users ssh key
   * @param apiKeyId 
   * @returns 
   */
  public delete(apiKeyId: string): Observable<null> {
    return this.http.delete<null>(`${this.endpoint}/${apiKeyId}`)
  }
}
